<ng-template #cardTemplate>
  @for (item of items$ | async; track item) {
    <div>
      <app-user-field-slot [userField]="item"></app-user-field-slot>
    </div>
  }
</ng-template>

<app-list title="User fields" [actions]="actions" [cardTemplate]="cardTemplate" i18n-title>
</app-list>
